// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6532":"68d757f1","8673":"653013e1"}[chunkId] + ".chunk.css";
};